import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface BadgeSummary {

  icon: string;
  name: string;
}

@Component({
  selector: 'app-badge-confirmation',
  templateUrl: './badge-confirmation.page.html',
  styleUrls: ['./badge-confirmation.page.scss'],
})
export class BadgeConfirmationPage {

  @Input() user: string;
  @Input() badges: BadgeSummary[];

  constructor(
    public modalController: ModalController
  ) { }
}
